module.exports = __webpack_public_path__ + "static/media/reward-card-pack-fallback-cover.a7f5f8d8.svg";